@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.veldekar.components.layouts.AboutMarkdownLayout as _com_veldekar_components_layouts_AboutMarkdownLayout
import com.veldekar.components.layouts.PageLayout as _com_veldekar_components_layouts_PageLayout
import com.veldekar.pages.AboutPage as _com_veldekar_pages_AboutPage
import com.veldekar.pages.HomePage as _com_veldekar_pages_HomePage
import com.veldekar.pages.Log as _com_veldekar_pages_Log
import com.veldekar.pages.MapPage as _com_veldekar_pages_MapPage
import com.veldekar.pages.SessionChartPage as _com_veldekar_pages_SessionChartPage
import com.veldekar.pages.SessionHeatmapPage as _com_veldekar_pages_SessionHeatmapPage
import com.veldekar.pages.SpellsPage as _com_veldekar_pages_SpellsPage
import com.veldekar.pages.log.Log_2023_01_14 as _com_veldekar_pages_log_Log_2023_01_14
import com.veldekar.pages.log.Log_2023_01_20 as _com_veldekar_pages_log_Log_2023_01_20
import com.veldekar.pages.log.Log_2023_01_27 as _com_veldekar_pages_log_Log_2023_01_27
import com.veldekar.pages.log.Log_2023_02_17 as _com_veldekar_pages_log_Log_2023_02_17
import com.veldekar.pages.log.Log_2023_03_03 as _com_veldekar_pages_log_Log_2023_03_03
import com.veldekar.pages.log.Log_2023_03_10 as _com_veldekar_pages_log_Log_2023_03_10
import com.veldekar.pages.log.Log_2023_03_17 as _com_veldekar_pages_log_Log_2023_03_17
import com.veldekar.pages.log.Log_2023_03_24 as _com_veldekar_pages_log_Log_2023_03_24
import com.veldekar.pages.log.Log_2023_03_31 as _com_veldekar_pages_log_Log_2023_03_31
import com.veldekar.pages.log.Log_2023_04_14 as _com_veldekar_pages_log_Log_2023_04_14
import com.veldekar.pages.log.Log_2023_05_12 as _com_veldekar_pages_log_Log_2023_05_12
import com.veldekar.pages.log.Log_2023_05_19 as _com_veldekar_pages_log_Log_2023_05_19
import com.veldekar.pages.log.Log_2023_05_26 as _com_veldekar_pages_log_Log_2023_05_26
import com.veldekar.pages.log.Log_2023_06_02 as _com_veldekar_pages_log_Log_2023_06_02
import com.veldekar.pages.log.Log_2023_06_09 as _com_veldekar_pages_log_Log_2023_06_09
import com.veldekar.pages.log.Log_2023_06_16 as _com_veldekar_pages_log_Log_2023_06_16
import com.veldekar.pages.log.Log_2023_06_23 as _com_veldekar_pages_log_Log_2023_06_23
import com.veldekar.pages.log.Log_2023_06_30 as _com_veldekar_pages_log_Log_2023_06_30
import com.veldekar.pages.log.Log_2023_07_14 as _com_veldekar_pages_log_Log_2023_07_14
import com.veldekar.pages.log.Log_2023_07_21 as _com_veldekar_pages_log_Log_2023_07_21
import com.veldekar.pages.log.Log_2023_07_28 as _com_veldekar_pages_log_Log_2023_07_28
import com.veldekar.pages.log.Log_2023_08_04 as _com_veldekar_pages_log_Log_2023_08_04
import com.veldekar.pages.log.Log_2023_08_11 as _com_veldekar_pages_log_Log_2023_08_11
import com.veldekar.pages.log.Log_2023_08_18 as _com_veldekar_pages_log_Log_2023_08_18
import com.veldekar.pages.log.Log_2023_08_25 as _com_veldekar_pages_log_Log_2023_08_25
import com.veldekar.pages.log.Log_2023_09_01 as _com_veldekar_pages_log_Log_2023_09_01
import com.veldekar.pages.log.Log_2023_11_19 as _com_veldekar_pages_log_Log_2023_11_19
import com.veldekar.pages.log.Log_2023_12_08 as _com_veldekar_pages_log_Log_2023_12_08
import com.veldekar.pages.log.Log_2023_12_15 as _com_veldekar_pages_log_Log_2023_12_15
import com.veldekar.pages.log.Log_2023_12_22 as _com_veldekar_pages_log_Log_2023_12_22
import com.veldekar.pages.log.Log_2024_01_26 as _com_veldekar_pages_log_Log_2024_01_26
import com.veldekar.pages.log.Log_2024_02_02 as _com_veldekar_pages_log_Log_2024_02_02
import com.veldekar.pages.log.Log_2024_02_23 as _com_veldekar_pages_log_Log_2024_02_23
import com.veldekar.pages.log.Log_2024_03_01 as _com_veldekar_pages_log_Log_2024_03_01
import com.veldekar.pages.log.Log_2024_03_08 as _com_veldekar_pages_log_Log_2024_03_08
import com.veldekar.pages.log.Log_2024_03_15 as _com_veldekar_pages_log_Log_2024_03_15
import com.veldekar.pages.log.Log_2024_04_05 as _com_veldekar_pages_log_Log_2024_04_05
import com.veldekar.pages.log.Log_2024_04_12 as _com_veldekar_pages_log_Log_2024_04_12
import com.veldekar.pages.log.Log_2024_04_19 as _com_veldekar_pages_log_Log_2024_04_19
import com.veldekar.pages.log.Log_2024_04_26 as _com_veldekar_pages_log_Log_2024_04_26
import com.veldekar.pages.log.Log_2024_05_03 as _com_veldekar_pages_log_Log_2024_05_03
import com.veldekar.pages.log.Log_2024_05_10 as _com_veldekar_pages_log_Log_2024_05_10
import com.veldekar.pages.log.Log_2024_05_17 as _com_veldekar_pages_log_Log_2024_05_17
import com.veldekar.pages.log.Log_2024_05_24 as _com_veldekar_pages_log_Log_2024_05_24
import com.veldekar.pages.log.Log_2024_07_05 as _com_veldekar_pages_log_Log_2024_07_05
import com.veldekar.pages.log.Log_2024_09_27 as _com_veldekar_pages_log_Log_2024_09_27
import com.veldekar.pages.log.Log_2024_10_11 as _com_veldekar_pages_log_Log_2024_10_11
import com.veldekar.pages.log.Log_2024_12_07 as _com_veldekar_pages_log_Log_2024_12_07
import com.veldekar.pages.log.Log_2024_12_28 as _com_veldekar_pages_log_Log_2024_12_28
import com.veldekar.pages.log.Log_2025_01_04 as _com_veldekar_pages_log_Log_2025_01_04
import com.veldekar.pages.log.Log_2025_01_11 as _com_veldekar_pages_log_Log_2025_01_11
import com.veldekar.pages.log.Log_2025_01_18 as _com_veldekar_pages_log_Log_2025_01_18
import com.veldekar.pages.log.Log_2025_01_25 as _com_veldekar_pages_log_Log_2025_01_25
import com.veldekar.pages.log.Log_2025_02_01 as _com_veldekar_pages_log_Log_2025_02_01
import com.veldekar.pages.log.Log_2025_02_08 as _com_veldekar_pages_log_Log_2025_02_08
import com.veldekar.pages.log.Log_2025_02_15 as _com_veldekar_pages_log_Log_2025_02_15
import com.veldekar.pages.log.Log_2025_02_22 as _com_veldekar_pages_log_Log_2025_02_22
import com.veldekar.pages.log.Log_2025_03_01 as _com_veldekar_pages_log_Log_2025_03_01
import com.veldekar.pages.log.Log_2025_03_15 as _com_veldekar_pages_log_Log_2025_03_15
import com.veldekar.pages.log.Log_2025_03_22 as _com_veldekar_pages_log_Log_2025_03_22
import com.veldekar.pages.log.Log_2025_03_29 as _com_veldekar_pages_log_Log_2025_03_29
import com.veldekar.pages.log.Log_2025_04_05 as _com_veldekar_pages_log_Log_2025_04_05
import com.veldekar.pages.log.Log_2025_04_12 as _com_veldekar_pages_log_Log_2025_04_12
import com.veldekar.pages.log.Log_2025_04_19 as _com_veldekar_pages_log_Log_2025_04_19
import com.veldekar.pages.log.Log_2025_04_26 as _com_veldekar_pages_log_Log_2025_04_26
import com.veldekar.pages.log.Log_2025_05_03 as _com_veldekar_pages_log_Log_2025_05_03
import com.veldekar.pages.log.Log_2025_05_10 as _com_veldekar_pages_log_Log_2025_05_10
import com.veldekar.pages.log.Log_2025_05_17 as _com_veldekar_pages_log_Log_2025_05_17
import com.veldekar.pages.log.Log_2025_05_24 as _com_veldekar_pages_log_Log_2025_05_24
import com.veldekar.pages.log.Log_2025_11_08 as _com_veldekar_pages_log_Log_2025_11_08
import com.veldekar.pages.log.Log_2025_11_15 as _com_veldekar_pages_log_Log_2025_11_15
import com.veldekar.pages.log.Log_2025_11_22 as _com_veldekar_pages_log_Log_2025_11_22
import com.veldekar.pages.log.Log_2025_11_29 as _com_veldekar_pages_log_Log_2025_11_29
import com.veldekar.pages.log.Log_2025_12_06 as _com_veldekar_pages_log_Log_2025_12_06
import com.veldekar.pages.log.Log_2025_12_13 as _com_veldekar_pages_log_Log_2025_12_13
import com.veldekar.pages.log.Log_2026_01_03 as _com_veldekar_pages_log_Log_2026_01_03
import com.veldekar.pages.log.Log_2026_01_10 as _com_veldekar_pages_log_Log_2026_01_10
import com.veldekar.pages.log.Log_2026_02_07 as _com_veldekar_pages_log_Log_2026_02_07
import com.veldekar.pages.log.Log_2026_02_14 as _com_veldekar_pages_log_Log_2026_02_14
import com.veldekar.pages.log.Log_2026_02_21 as _com_veldekar_pages_log_Log_2026_02_21
import com.veldekar.pages.log.Log_2026_03_07 as _com_veldekar_pages_log_Log_2026_03_07
import com.veldekar.pages.log.Log_2026_03_14 as _com_veldekar_pages_log_Log_2026_03_14
import com.veldekar.pages.log.Log_2026_03_21 as _com_veldekar_pages_log_Log_2026_03_21
import com.veldekar.pages.log.Log_2026_03_28 as _com_veldekar_pages_log_Log_2026_03_28
import com.veldekar.pages.log.Log_2026_04_11 as _com_veldekar_pages_log_Log_2026_04_11
import com.veldekar.pages.log.Log_2026_04_18 as _com_veldekar_pages_log_Log_2026_04_18
import com.veldekar.pages.log.Log_2026_05_02 as _com_veldekar_pages_log_Log_2026_05_02
import com.veldekar.pages.log.Log_2026_05_09 as _com_veldekar_pages_log_Log_2026_05_09
import com.veldekar.pages.log.Log_2026_05_23 as _com_veldekar_pages_log_Log_2026_05_23
import com.veldekar.pages.log.Log_2026_05_30 as _com_veldekar_pages_log_Log_2026_05_30
import com.veldekar.pages.log.Log_2026_06_06 as _com_veldekar_pages_log_Log_2026_06_06
import com.veldekar.pages.log.Log_2026_08_01 as _com_veldekar_pages_log_Log_2026_08_01
import com.veldekar.pages.log.Log_2026_08_08 as _com_veldekar_pages_log_Log_2026_08_08
import com.veldekar.pages.log.Log_2026_08_29 as _com_veldekar_pages_log_Log_2026_08_29
import com.veldekar.pages.log.Log_2026_09_12 as _com_veldekar_pages_log_Log_2026_09_12
import com.veldekar.pages.log.Log_2026_10_10 as _com_veldekar_pages_log_Log_2026_10_10
import com.veldekar.pages.spells.BlessPage as _com_veldekar_pages_spells_BlessPage
import com.veldekar.pages.spells.CalmEmotionsPage as _com_veldekar_pages_spells_CalmEmotionsPage
import com.veldekar.pages.spells.ChainLightningPage as _com_veldekar_pages_spells_ChainLightningPage
import com.veldekar.pages.spells.CommandPage as _com_veldekar_pages_spells_CommandPage
import com.veldekar.pages.spells.ComprehendLanguagesPage as _com_veldekar_pages_spells_ComprehendLanguagesPage
import com.veldekar.pages.spells.ConeOfColdPage as _com_veldekar_pages_spells_ConeOfColdPage
import com.veldekar.pages.spells.CounterspellPage as _com_veldekar_pages_spells_CounterspellPage
import com.veldekar.pages.spells.CreateFoodAndWaterPage as _com_veldekar_pages_spells_CreateFoodAndWaterPage
import com.veldekar.pages.spells.DarknessPage as _com_veldekar_pages_spells_DarknessPage
import com.veldekar.pages.spells.FireballPage as _com_veldekar_pages_spells_FireballPage
import com.veldekar.pages.spells.HastePage as _com_veldekar_pages_spells_HastePage
import com.veldekar.pages.spells.HeatMetalPage as _com_veldekar_pages_spells_HeatMetalPage
import com.veldekar.pages.spells.HoldPersonPage as _com_veldekar_pages_spells_HoldPersonPage
import com.veldekar.pages.spells.IceStormPage as _com_veldekar_pages_spells_IceStormPage
import com.veldekar.pages.spells.MagnificentMansionPage as _com_veldekar_pages_spells_MagnificentMansionPage
import com.veldekar.pages.spells.PolymorphPage as _com_veldekar_pages_spells_PolymorphPage
import com.veldekar.pages.spells.PrestidigitationPage as _com_veldekar_pages_spells_PrestidigitationPage
import com.veldekar.pages.spells.ScorchingRayPage as _com_veldekar_pages_spells_ScorchingRayPage
import com.veldekar.pages.spells.ScryingPage as _com_veldekar_pages_spells_ScryingPage
import com.veldekar.pages.spells.SendingPage as _com_veldekar_pages_spells_SendingPage
import com.veldekar.pages.spells.TeleportationCirclePage as _com_veldekar_pages_spells_TeleportationCirclePage
import com.veldekar.pages.spells.TinyHutPage as _com_veldekar_pages_spells_TinyHutPage
import com.veldekar.pages.spells.WallOfFirePage as _com_veldekar_pages_spells_WallOfFirePage
import com.veldekar.pages.spells.WindWalkPage as _com_veldekar_pages_spells_WindWalkPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Veldekar"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.veldekar.components.layouts.AboutMarkdownLayout",
            parentLayoutId = "com.veldekar.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.veldekar.components.layouts.initMarkdownLayouts(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _com_veldekar_components_layouts_AboutMarkdownLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "com.veldekar.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_veldekar_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "com.veldekar.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.veldekar.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_HomePage()
        }
        ctx.router.register(
            "/2023-01-14",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_01_14(pageCtx)
        }
        ctx.router.register(
            "/2023-01-20",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_01_20(pageCtx)
        }
        ctx.router.register(
            "/2023-01-27",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_01_27(pageCtx)
        }
        ctx.router.register(
            "/2023-02-17",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_02_17(pageCtx)
        }
        ctx.router.register(
            "/2023-03-03",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_03_03(pageCtx)
        }
        ctx.router.register(
            "/2023-03-10",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_03_10(pageCtx)
        }
        ctx.router.register(
            "/2023-03-17",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_03_17(pageCtx)
        }
        ctx.router.register(
            "/2023-03-24",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_03_24(pageCtx)
        }
        ctx.router.register(
            "/2023-03-31",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_03_31(pageCtx)
        }
        ctx.router.register(
            "/2023-04-14",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_04_14(pageCtx)
        }
        ctx.router.register(
            "/2023-05-12",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_05_12(pageCtx)
        }
        ctx.router.register(
            "/2023-05-19",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_05_19(pageCtx)
        }
        ctx.router.register(
            "/2023-05-26",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_05_26(pageCtx)
        }
        ctx.router.register(
            "/2023-06-02",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_06_02(pageCtx)
        }
        ctx.router.register(
            "/2023-06-09",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_06_09(pageCtx)
        }
        ctx.router.register(
            "/2023-06-16",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_06_16(pageCtx)
        }
        ctx.router.register(
            "/2023-06-23",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_06_23(pageCtx)
        }
        ctx.router.register(
            "/2023-06-30",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_06_30(pageCtx)
        }
        ctx.router.register(
            "/2023-07-14",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_07_14(pageCtx)
        }
        ctx.router.register(
            "/2023-07-21",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_07_21(pageCtx)
        }
        ctx.router.register(
            "/2023-07-28",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_07_28(pageCtx)
        }
        ctx.router.register(
            "/2023-08-04",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_08_04(pageCtx)
        }
        ctx.router.register(
            "/2023-08-11",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_08_11(pageCtx)
        }
        ctx.router.register(
            "/2023-08-18",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_08_18(pageCtx)
        }
        ctx.router.register(
            "/2023-08-25",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_08_25(pageCtx)
        }
        ctx.router.register(
            "/2023-09-01",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_09_01(pageCtx)
        }
        ctx.router.register(
            "/2023-11-19",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_11_19(pageCtx)
        }
        ctx.router.register(
            "/2023-12-08",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_12_08(pageCtx)
        }
        ctx.router.register(
            "/2023-12-15",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_12_15(pageCtx)
        }
        ctx.router.register(
            "/2023-12-22",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2023_12_22(pageCtx)
        }
        ctx.router.register(
            "/2024-01-26",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_01_26(pageCtx)
        }
        ctx.router.register(
            "/2024-02-02",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_02_02(pageCtx)
        }
        ctx.router.register(
            "/2024-02-23",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_02_23(pageCtx)
        }
        ctx.router.register(
            "/2024-03-01",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_03_01(pageCtx)
        }
        ctx.router.register(
            "/2024-03-08",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_03_08(pageCtx)
        }
        ctx.router.register(
            "/2024-03-15",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_03_15(pageCtx)
        }
        ctx.router.register(
            "/2024-04-05",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_04_05(pageCtx)
        }
        ctx.router.register(
            "/2024-04-12",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_04_12(pageCtx)
        }
        ctx.router.register(
            "/2024-04-19",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_04_19(pageCtx)
        }
        ctx.router.register(
            "/2024-04-26",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_04_26(pageCtx)
        }
        ctx.router.register(
            "/2024-05-03",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_05_03(pageCtx)
        }
        ctx.router.register(
            "/2024-05-10",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_05_10(pageCtx)
        }
        ctx.router.register(
            "/2024-05-17",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_05_17(pageCtx)
        }
        ctx.router.register(
            "/2024-05-24",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_05_24(pageCtx)
        }
        ctx.router.register(
            "/2024-07-05",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_07_05(pageCtx)
        }
        ctx.router.register(
            "/2024-09-27",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_09_27(pageCtx)
        }
        ctx.router.register(
            "/2024-10-11",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_10_11(pageCtx)
        }
        ctx.router.register(
            "/2024-12-07",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_12_07(pageCtx)
        }
        ctx.router.register(
            "/2024-12-28",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2024_12_28(pageCtx)
        }
        ctx.router.register(
            "/2025-01-04",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_01_04(pageCtx)
        }
        ctx.router.register(
            "/2025-01-11",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_01_11(pageCtx)
        }
        ctx.router.register(
            "/2025-01-18",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_01_18(pageCtx)
        }
        ctx.router.register(
            "/2025-01-25",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_01_25(pageCtx)
        }
        ctx.router.register(
            "/2025-02-01",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_02_01(pageCtx)
        }
        ctx.router.register(
            "/2025-02-08",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_02_08(pageCtx)
        }
        ctx.router.register(
            "/2025-02-15",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_02_15(pageCtx)
        }
        ctx.router.register(
            "/2025-02-22",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_02_22(pageCtx)
        }
        ctx.router.register(
            "/2025-03-01",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_03_01(pageCtx)
        }
        ctx.router.register(
            "/2025-03-15",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_03_15(pageCtx)
        }
        ctx.router.register(
            "/2025-03-22",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_03_22(pageCtx)
        }
        ctx.router.register(
            "/2025-03-29",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_03_29(pageCtx)
        }
        ctx.router.register(
            "/2025-04-05",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_04_05(pageCtx)
        }
        ctx.router.register(
            "/2025-04-12",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_04_12(pageCtx)
        }
        ctx.router.register(
            "/2025-04-19",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_04_19(pageCtx)
        }
        ctx.router.register(
            "/2025-04-26",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_04_26(pageCtx)
        }
        ctx.router.register(
            "/2025-05-03",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_05_03(pageCtx)
        }
        ctx.router.register(
            "/2025-05-10",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_05_10(pageCtx)
        }
        ctx.router.register(
            "/2025-05-17",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_05_17(pageCtx)
        }
        ctx.router.register(
            "/2025-05-24",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_05_24(pageCtx)
        }
        ctx.router.register(
            "/2025-11-08",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_11_08(pageCtx)
        }
        ctx.router.register(
            "/2025-11-15",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_11_15(pageCtx)
        }
        ctx.router.register(
            "/2025-11-22",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_11_22(pageCtx)
        }
        ctx.router.register(
            "/2025-11-29",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_11_29(pageCtx)
        }
        ctx.router.register(
            "/2025-12-06",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_12_06(pageCtx)
        }
        ctx.router.register(
            "/2025-12-13",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2025_12_13(pageCtx)
        }
        ctx.router.register(
            "/2026-01-03",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_01_03(pageCtx)
        }
        ctx.router.register(
            "/2026-01-10",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_01_10(pageCtx)
        }
        ctx.router.register(
            "/2026-02-07",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_02_07(pageCtx)
        }
        ctx.router.register(
            "/2026-02-14",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_02_14(pageCtx)
        }
        ctx.router.register(
            "/2026-02-21",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_02_21(pageCtx)
        }
        ctx.router.register(
            "/2026-03-07",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_03_07(pageCtx)
        }
        ctx.router.register(
            "/2026-03-14",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_03_14(pageCtx)
        }
        ctx.router.register(
            "/2026-03-21",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_03_21(pageCtx)
        }
        ctx.router.register(
            "/2026-03-28",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_03_28(pageCtx)
        }
        ctx.router.register(
            "/2026-04-11",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_04_11(pageCtx)
        }
        ctx.router.register(
            "/2026-04-18",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_04_18(pageCtx)
        }
        ctx.router.register(
            "/2026-05-02",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_05_02(pageCtx)
        }
        ctx.router.register(
            "/2026-05-09",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_05_09(pageCtx)
        }
        ctx.router.register(
            "/2026-05-23",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_05_23(pageCtx)
        }
        ctx.router.register(
            "/2026-05-30",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_05_30(pageCtx)
        }
        ctx.router.register(
            "/2026-06-06",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_06_06(pageCtx)
        }
        ctx.router.register(
            "/2026-08-01",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_08_01(pageCtx)
        }
        ctx.router.register(
            "/2026-08-08",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_08_08(pageCtx)
        }
        ctx.router.register(
            "/2026-08-29",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_08_29(pageCtx)
        }
        ctx.router.register(
            "/2026-09-12",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_09_12(pageCtx)
        }
        ctx.router.register(
            "/2026-10-10",
        ) { pageCtx -> 
            _com_veldekar_pages_log_Log_2026_10_10(pageCtx)
        }
        ctx.router.register(
            "/about",
            layoutId = "com.veldekar.components.layouts.AboutMarkdownLayout",
            initRouteMethod = { ctx ->
                com.veldekar.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_AboutPage()
        }
        ctx.router.register(
            "/log",
        ) { pageCtx -> 
            _com_veldekar_pages_Log(pageCtx)
        }
        ctx.router.register(
            "/map",
        ) { pageCtx -> 
            _com_veldekar_pages_MapPage()
        }
        ctx.router.register(
            "/session-chart",
            layoutId = "com.veldekar.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.veldekar.pages.initSessionBarChartPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_SessionChartPage()
        }
        ctx.router.register(
            "/session-heatmap",
            layoutId = "com.veldekar.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.veldekar.pages.initSessionHeatmapPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_SessionHeatmapPage()
        }
        ctx.router.register(
            "/spell-bless",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initBlessPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_BlessPage()
        }
        ctx.router.register(
            "/spell-calm-emotions",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initCalmEmotionsPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_CalmEmotionsPage()
        }
        ctx.router.register(
            "/spell-chain-lightning",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initChainLightningPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_ChainLightningPage()
        }
        ctx.router.register(
            "/spell-command",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initCommandPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_CommandPage()
        }
        ctx.router.register(
            "/spell-comprehend-languages",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initComprehendLanguagesPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_ComprehendLanguagesPage()
        }
        ctx.router.register(
            "/spell-cone-of-cold",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initConeOfColdPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_ConeOfColdPage()
        }
        ctx.router.register(
            "/spell-counterspell",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initCounterspellPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_CounterspellPage()
        }
        ctx.router.register(
            "/spell-create-food-and-water",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initCreateFoodAndWaterPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_CreateFoodAndWaterPage()
        }
        ctx.router.register(
            "/spell-darkness",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initDarknessPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_DarknessPage()
        }
        ctx.router.register(
            "/spell-fireball",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initFireballPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_FireballPage()
        }
        ctx.router.register(
            "/spell-haste",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initHastePage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_HastePage()
        }
        ctx.router.register(
            "/spell-heat-metal",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initHeatMetalPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_HeatMetalPage()
        }
        ctx.router.register(
            "/spell-hold-person",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initHoldPersonPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_HoldPersonPage()
        }
        ctx.router.register(
            "/spell-ice-storm",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initIceStormPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_IceStormPage()
        }
        ctx.router.register(
            "/spell-magnificent-mansion",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initMagnificentMansionPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_MagnificentMansionPage()
        }
        ctx.router.register(
            "/spell-polymorph",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initPolymorphPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_PolymorphPage()
        }
        ctx.router.register(
            "/spell-prestidigitation",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initPrestidigitationPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_PrestidigitationPage()
        }
        ctx.router.register(
            "/spell-scorching-ray",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initScorchingRayPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_ScorchingRayPage()
        }
        ctx.router.register(
            "/spell-scrying",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initScryingPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_ScryingPage()
        }
        ctx.router.register(
            "/spell-sending",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initSendingPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_SendingPage()
        }
        ctx.router.register(
            "/spell-teleportation-circle",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initTeleportationCirclePage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_TeleportationCirclePage()
        }
        ctx.router.register(
            "/spell-tiny-hut",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initTinyHutPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_TinyHutPage()
        }
        ctx.router.register(
            "/spell-wall-of-fire",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initWallOfFirePage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_WallOfFirePage()
        }
        ctx.router.register(
            "/spell-wind-walk",
            initRouteMethod = { ctx ->
                com.veldekar.pages.spells.initWindWalkPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_spells_WindWalkPage()
        }
        ctx.router.register(
            "/spells",
            initRouteMethod = { ctx ->
                com.veldekar.pages.initSpellsPage(ctx)
            },
        ) { pageCtx -> 
            _com_veldekar_pages_SpellsPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", com.veldekar.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.veldekar.SubheadlineTextStyle)
        ctx.theme.registerStyle("footer", com.veldekar.components.sections.FooterStyle)
        ctx.theme.registerStyle("nav-header", com.veldekar.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("more-menu-popover", com.veldekar.components.sections.MoreMenuPopoverStyle)
        ctx.theme.registerStyle("markdown", com.veldekar.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("about-markdown", com.veldekar.components.layouts.AboutMarkdownStyle)
        ctx.theme.registerStyle("log-markdown", com.veldekar.components.layouts.LogMarkdownStyle)
        ctx.theme.registerStyle("visually-hidden", com.veldekar.components.layouts.VisuallyHiddenStyle)
        ctx.theme.registerStyle("page-content", com.veldekar.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("session-list-item-container", com.veldekar.components.log.SessionListItemContainerStyle)
        ctx.theme.registerStyle("session-list-item-image", com.veldekar.components.log.SessionListItemImageStyle)
        ctx.theme.registerStyle("session-list-item-text-column", com.veldekar.components.log.SessionListItemTextColumnStyle)
        ctx.theme.registerStyle("bookmark-item", com.veldekar.components.widgets.BookmarkItemStyle)
        ctx.theme.registerStyle("hero-container", com.veldekar.pages.HeroContainerStyle)
        ctx.theme.registerStyle("section-header", com.veldekar.pages.SectionHeaderStyle)
        ctx.theme.registerStyle("home-grid", com.veldekar.pages.HomeGridStyle)
        ctx.theme.registerStyle("home-grid-cell", com.veldekar.pages.HomeGridCellStyle)
        ctx.theme.registerVariant("-circle", com.veldekar.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", com.veldekar.UncoloredButtonVariant)
        ctx.theme.registerVariant("-sort", com.veldekar.pages.SortButtonVariant)
        ctx.theme.registerKeyframes("side-menu-slide-in", com.veldekar.components.sections.SideMenuSlideInAnim)
        com.veldekar.initSiteStyles(ctx)
        com.veldekar.initColorMode(ctx)
        com.veldekar.initStyles(ctx)
        com.veldekar.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.veldekar.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
